export enum DROPDOWN_LABELS {
  PERFORMANCE = "performance",
  EARLY_INCENTIVES = "earlyIncentives",
  MY_GROUP = "myGroup",
  LEADER_GROWTH = "leaderGrowth",
  RESOURCES = "resources",
  ACADEMY = "academy",
}

export enum DROPDOWN_KEYS {
  PERFORMANCE = "performance",
  EARLY_INCENTIVES = "earlyIncentives",
  MY_GROUP = "myGroup",
  LEADER_GROWTH = "leaderGrowth",
  RESOURCES = "resources",
  ACADEMY = "academy",
}

export enum ROUTE_LABELS {
  PERFORMANCE_BONUS = "performanceBonus",
  EARNINGS_CALCULATOR = "earningsCalculator",
  CSI = "csi",
  BF_PLUS = "bronzeFoundation",
  BRONZE_FOUNDATION_INCENTIVE = "bronzeFoundationIncentive",
  BB_PLUS = "bronzeBuilder",
  BRONZE_BUILDER_INCENTIVE = "bronzeBuilderIncentive",
  CUSTOMER_MEMBER_LIST = "customerMemberList",
  LOS = "los",
  EDLOS = "edlos",
  WATCHLIST = "watchlist",
  PERFORMANCE_PLUS = "performancePlus",
  PERFORMANCE_ELITE = "performanceElite",
  PPE = "performancePlusElite",
  PGG = "personalGrowth",
  MONTHLY_PGG = "personalGrowthMonthly",
  MONTHLY_PGGI = "monthlyPGGI",
  ANNUAL_PGG = "personalGrowthAnnual",
  PGTI = "personalGroupTieredIncentive",
  PGG_GCR = "personalGroupGrowthGCR",
  PERSONAL_GROUP_GROWTH = "personalGroupGrowth",
  FGG = "frontlineGrowth",
  TTCI = "twoTimeCashIncentive",
  FEEDBACK = "feedback",
  LEARN_ABOUT_CPP = "learnAboutCpp",
  LEARN_ABOUT_CORE_PLAN = "learnAboutCorePlan",
  LOG_OUT = "logOut",
  HAT = "hat",
  GAR = "gar",
  FAA = "faa",
  LEADERSHIP_SEMINAR = "leadershipSeminar",
  LEADERSHIP_SEMINAR_ESAN = "leadershipSeminarEsan",
  RUBY = "ruby",
  LEADERSHIP = "leadership",
  FOSTER = "fosterString",
  INTERNATIONAL_LEADERSHIP = "internationalLeadership",
  DEPTH = "depth",
  CBR = "cbrActionReport",
  CVR = "cvrActionReport",
  IBO_ONBOARDING = "iboOnboardingActionReport",
  PATH_TO_BRONZE = "newAboActivation",
  BIRTHDAYS_ACTION_REPORT = "birthdaysActionReport",
  WHOS_NEW_ACTION_REPORT = "whosNewActionReport",
  WHOS_CLOSE_ACTION_REPORT = "whosCloseActionReport",
  BRONZE_GROUP_TRACKING = "bronzeGroupTracking",
  RENEWALS = "renewalsActionReport",
  NON_BONUSABLE_BV_ACTION_REPORT = "nonBonusableBvActionReport",
  MBI = "mbi",
  ACADEMY = "academy",
  PERFORMANCE_DASHBOARD = "performanceDashboard",
  STRONG_START_INCENTIVE = "strongStartIncentive",
  BRONZE_INCENTIVES = "bronzeIncentives",
  QC_GROWTH = "qcg",
  VISION_BONUS = "visionBonus",
  MONTHLY_Q = "monthlyQ",
  HEALTH_WELLBEING = "healthWellbeing",
  ANNUAL_Q = "annualq",
  FRONTLINE_Q = "frontlineQ",
  LEADERSHIP_PLUS = "leadershipPlus",
  SSI_UPLINE_REPORT = "ssiUplineReport",
  PATH_TO_A70 = "pathToA70",
  DIAMOND_BONUS = "diamondBonus",
  A70_ELITE_BONUS = "a70EliteBonus",
  ONLINE_STATEMENTS = "onlineStatements",
  RETRO_PV_INQUIRY = "retroPvInquiry",
  FOUNDERS_SALES_INCENTIVE = "foundersSalesIncentive",
  FSI_ACTION_REPORT = "fsiActionReport",
  LEADER_INCENTIVE = "leaderIncentive",
}

export enum ROUTE_PATHS {
  PERFORMANCE_BONUS = "/performance-bonus",
  EARNINGS_CALCULATOR = "/calculator.html",
  CSI = "/csi",
  CML = "/cml.html",
  CUSTOMER_LIST = "/customer/list",
  CUSTOMER_ORDER = "/customer/order",
  LOS = "/rwlos.html",
  EDLOS = "/edlos",
  EDLOS_DOWNLINE = "/$__los-ed/downline-los",
  WATCHLIST = "/watchlist.html",
  PPE = "/performance-plus-elite",
  MONTHLY_PGG = "/personal-growth-monthly",
  ANNUAL_PGG = "/personal-growth",
  PGG_GCR = "/personal-growth-gcr",
  FGG = "/frontline-growth",
  TWO_TIME_CASH_INCENTIVE = "/ttci",
  FEEDBACK = "/provide-feedback",
  LEARN_ABOUT_CPP = "/learn-about-cpp",
  LEARN_ABOUT_CORE_PLAN = "/learn-about-core-plan",
  LOG_OUT = "/log-out",
  HAT = "/hat",
  HAT_ABO_TRACKING = "/$__hat/abo-tracking",
  HAT_QC_DETAILS = "/$__hat/leg-qc-details",
  GAR_LEG_QC_DETAILS = "/gar/leg-qc-details",
  FAA = "/faa",
  LEADERSHIP_SEMINAR = "/leadership-seminar",
  CBR = "/cbr-action-report.html",
  CVR = "/cvr-action-report.html",
  IBO_ONBOARDING = "/ibo-onboarding-action-report.html",
  BIRTHDAYS_ACTION_REPORT = "/birthdays-action-report.html",
  WHOS_NEW_ACTION_REPORT = "/whos-new-action-report.html",
  WHOS_CLOSE_ACTION_REPORT = "/whos-close-action-report.html",
  BRONZE_GROUP_TRACKING = "/bronze-group-tracking",
  SOP_REPORT = "/sop-report",
  NON_BONUSABLE_BV_ACTION_REPORT = "/nbbv-action-report.html",
  RENEWALS = "/renewals-action-report",
  SAQ_ACTION_REPORT = "/saq-action-report",
  FSI_ACTION_REPORT = "/fsi-action-report",
  SSI_UPLINE_REPORT = "/ssi-upline-report.html",
  MBI = "/mbi",
  MBIMonthlyBonuses = "/mbi/monthly",
  MAINTENANCE = "/maintenance",
  PERFORMANCE_DASHBOARD = "/performance-dashboard",
  PERFORMANCE_PLUS = "/performance-plus",
  MONTHLY_PERFORMANCE = "/performance-dashboard#monthly",
  ANNUAL_PERFORMANCE = "/performance-dashboard#annual",
  GROUP_MANAGEMENT_DASHBOARD = "/group-management",
  STRONG_START_INCENTIVE = "/strong-start-incentive",
  BRONZE_INCENTIVES = "/bronze-incentives",
  QC_GROWTH = "/qc-growth",
  VISION_BONUS = "/vision-bonus",
  NEW_PATH_TO_BRONZE = "/bronze-incentives#pathtobronze",
  NEW_BRONZE_FOUNDATION = "/bronze-incentives#bronzefoundation",
  NEW_BRONZE_BUILDER = "/bronze-incentives#bronzebuilder",
  MONTHLY_Q = "/monthlyQ",
  Q_GROWTH_INCENTIVE = "/q-growth-incentive",
  EARLY_Q_BOOSTER = "/early-q-booster",
  HEALTH_WELLBEING = "/health-wellbeing",
  ANNUALQ = "/annualq",
  FRONTLINE_Q = "/frontlineQ",
  LEADERSHIP_PLUS = "/leadership-plus",
  DIAMOND_BONUS = "/100-diamond-bonus",
  PATH_TO_A70 = "/100-diamond-bonus",
  A70_ELITE_BONUS = "/100-diamond-bonus",
  ACADEMY_AUTH = "/academy/auth",
  ONLINE_STATEMENTS = "/online-statements",
  RETRO_PV_INQUIRY = "/retro-pv-inquiry.html",
  FOUNDERS_SALES_INCENTIVE = "/founders-sales-incentive",
  LEADER_INCENTIVE = "/leader-incentive",
}

export const FAA_SUB_ROUTES = ["/faa/leg-point-tracking-details", "/faa/abo-tracking", "/faa/core-plan-income"];

export const ANNUAL_INCENTIVES_PATHNAMES: string[] = [
  ROUTE_PATHS.ANNUAL_PGG,
  ROUTE_PATHS.PGG_GCR,
  ROUTE_PATHS.FGG,
  ROUTE_PATHS.TWO_TIME_CASH_INCENTIVE,
  ROUTE_PATHS.ANNUAL_PERFORMANCE,
  ROUTE_PATHS.VISION_BONUS,
  ROUTE_PATHS.FRONTLINE_Q,
  ROUTE_PATHS.LEADERSHIP_PLUS,
  ROUTE_PATHS.QC_GROWTH,
  ROUTE_PATHS.HEALTH_WELLBEING,
  ROUTE_PATHS.ANNUALQ,
  ROUTE_PATHS.DIAMOND_BONUS,
  ROUTE_PATHS.PATH_TO_A70,
  ROUTE_PATHS.A70_ELITE_BONUS,
  ROUTE_PATHS.FOUNDERS_SALES_INCENTIVE,
  ROUTE_PATHS.LEADER_INCENTIVE,
];

export enum ROUTE_VIEWS_ID {
  PPV2_VIEW_ID = "PPv2",
  ANNUAL_Q = "annualQ",
}
